import React from 'react';

const Problem = () => {
  return (
    <section id="problema" className="bg-white py-16 pb-8">
      <div className="container-max px-6 sm:px-8 lg:px-12">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-8">
            Entre planeaciones, tareas y evaluaciones…<br className="hidden md:block" />
            preparar actividades puede quitarte horas cada semana.
          </h2>
        </div>
      </div>
    </section>
  );
};

export default Problem;